<template>
	<validation-observer ref="refForm">
		<b-form
			@submit.prevent="onSubmit"
			@reset.prevent="resetForm"
		>
			<b-row>
				<b-col md="12">
					<b-card
						footer-tag="footer"
						class="mb-0"
					>
						<b-row>
							<!-- PROVIDER NAME -->
							<b-col
								cols="12"
								class="mb-2"
							>
								<label for="name">
									<strong>
										RAZÓN SOCIAL
										<span class="text-danger">*</span>
									</strong>
								</label>
								<validation-provider
									#default="{ errors }"
									rules="required"
									name="Razón Social"
								>
									<b-form-input
										id="name"
										v-model="formData.name"
										placeholder="Ingrese razón social ..."
										:state="errors.length > 0 ? false : null"
										trim
									/>

									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-col>

							<!-- ALIAS -->
							<b-col
								md="4"
								cols="12"
								class="mb-2"
							>
								<label for="alias">
									<strong>NOMBRE COMERCIAL (Abreviatura)</strong>
								</label>
								<validation-provider
									#default="{ errors }"
									name="Nombre Comercial"
								>
									<b-form-input
										id="alias"
										v-model="formData.alias"
										placeholder="Ingrese nombre comercial ..."
										:state="errors.length > 0 ? false : null"
										trim
									/>

									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-col>

							<!-- RUC -->
							<b-col
								md="4"
								cols="12"
								class="mb-2"
							>
								<label for="ruc">
									<strong>
										RUC
										<span class="text-danger">*</span>
									</strong>
								</label>
								<validation-provider
									#default="{ errors }"
									rules="required"
									name="RUC"
								>
									<b-form-input
										id="ruc"
										v-model="formData.ruc"
										placeholder="Ingrese el RUC ..."
										:state="errors.length > 0 ? false : null"
										trim
									/>

									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-col>

							<!-- BUSINESS AREA -->
							<b-col
								md="4"
								cols="12"
								class="mb-2"
							>
								<label for="businessArea">
									<strong>
										RUBRO
										<span class="text-danger">*</span>
									</strong>
								</label>
								<validation-provider
									#default="{ errors }"
									rules="required"
									name="Rubro"
								>
									<v-select
										id="businessArea"
										placeholder="Seleccione"
										v-model="formData.businessArea"
										@input="changePerformanceGroup"
										:state="errors.length > 0 ? false : null"
										:options="options.businessAreas"
									/>

									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-col>

							<b-col
								md="4"
								cols="12"
								class="mb-2"
							>
								<label for="general_manager">
									<strong>
										GERENTE GENERAL
										<span class="text-info">*</span>
									</strong>
								</label>
								<validation-provider
									#default="{ errors }"
									:rules="formData.has_performance && formData.has_performance.value ? 'required' : ''"
									name="Gerente General"
								>
									<b-form-input
										id="general_manager"
										v-model="formData.general_manager"
										placeholder="Ej. Nombre Apellido 1, Nombre Apellido 2"
										:state="errors.length > 0 ? false : null"
										trim
									/>

									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-col>

							<b-col
								md="4"
								cols="12"
								class="mb-2"
							>
								<label for="physical_address">
									<strong>DIRECCIÓN FÍSICA</strong>
								</label>
								<validation-provider
									#default="{ errors }"
									name="Dirección Física"
								>
									<b-form-input
										id="physical_address"
										v-model="formData.physical_address"
										placeholder="Ingrese dirección física"
										:state="errors.length > 0 ? false : null"
										trim
									/>

									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-col>

							<b-col
								md="4"
								cols="12"
								class="mb-2"
							>
								<label for="email">
									<strong>
										CORREO ELECTRÓNICO
										<span class="text-danger">*</span>
									</strong>
								</label>
								<validation-provider
									#default="{ errors }"
									name="Correo Electrónico"
									rules="required|email"
								>
									<b-form-input
										id="email"
										v-model="formData.email"
										placeholder="Ingrese correo electrónico..."
										:state="errors.length > 0 ? false : null"
										trim
									/>

									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-col>
						</b-row>

						<!-- EMAIL ALTERNATE-->
						<b-row
							cols="12"
							class="mb-1"
							v-for="(other, index) in other_emails"
							:key="index"
						>
							<b-col
								cols="12"
								v-if="index===0"
							>
								<label for="alternate_email">
									<strong>CORREO ELECTRÓNICO SECUNDARIO</strong>
									<feather-icon
										variant="primary"
										icon="AlertCircleIcon"
										v-b-tooltip.hover.right="'Los correos secundarios solo recibirán notificaciones'"
										class="ml-1"
									/>
								</label>
							</b-col>

							<b-col
								:cols="index === 0 ? '12' : '10'"
								:lg="index === 0 ? '12' : '11'"
							>
								<validation-provider
									#default="{ errors }"
									rules="email"
									name="correo electrónico secundario"
								>
									<b-form-input
										:id="`alternate_email-${other.id}`"
										v-model="other.email"
										placeholder="Ingrese el correo electrónico secundario ..."
										:state="errors.length > 0 ? false : null"
										trim
									/>
									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-col>

							<b-col
								cols="2"
								lg="1"
								class="text-center"
							>
								<b-button
									v-if="index !== 0"
									v-ripple.400="'rgba(40, 199, 111, 0.15)'"
									variant="flat-danger"
									class="btn-icon rounded-circle"
									@click="removeSecondaryEmail(index)"
								>
									<feather-icon icon="TrashIcon" />
								</b-button>
							</b-col>
						</b-row>

						<b-row>
							<b-col>
								<b-button
									v-ripple.400="'rgba(255, 255, 255, 0.15)'"
									variant="outline-primary"
									size="sm"
									@click="addSecondaryEmail()"
								>
									<feather-icon
										icon="PlusIcon"
										class="mr-25"
									/>
									<span>AGREGAR OTRO CORREO</span>
								</b-button>
							</b-col>
						</b-row>

						<b-row class="mt-2">
							<b-col cols="12">
								<b-card no-body>
									<b-card-title class="text-info">EVALUACIÓN DE DESEMPEÑO</b-card-title>
									<b-row>
										<b-col
											md="4"
											cols="12"
											class="mb-2"
										>
											<label for="has_performance">
												<strong>
													¿TIENE EVALUACIÓN?
													<span class="text-danger">*</span>
												</strong>
											</label>
											<validation-provider
												#default="{ errors }"
												rules="required"
												name="¿Tiene evaluación?"
											>
												<v-select
													id="has_performance"
													placeholder="Seleccione"
													v-model="formData.has_performance"
													@input="changeHasPerformance"
													:state="errors.length > 0 ? false : null"
													:options="options.hasPerformances"
												/>

												<small class="text-danger">{{ errors[0] }}</small>
											</validation-provider>
										</b-col>

										<template v-if="formData.has_performance && formData.has_performance.value">
											<!-- ORDER NUMBER -->
											<b-col
												md="4"
												cols="12"
												class="mb-2"
											>
												<label for="order_number">
													<strong>
														NRO ORDEN (Carta Mensual)
														<span class="text-info">*</span>
													</strong>
												</label>

												<validation-provider
													#default="{ errors }"
													rules="required"
													name="Bro Orden"
												>
													<b-form-input
														id="order_number"
														v-model="formData.order_number"
														placeholder="Ingrese el nro de orden ..."
														trim
													/>
													<small class="text-danger">{{ errors[0] }}</small>
												</validation-provider>
											</b-col>

											<!-- BUSINESS AREA -->
											<b-col
												md="4"
												cols="12"
												class="mb-2"
											>
												<label for="performance_group">
													<strong>
														GRUPO DE EVALUACIÓN
														<span class="text-info">*</span>
													</strong>
												</label>
												<validation-provider
													#default="{ errors }"
													rules="required"
													name="Grupo de evaluación"
												>
													<v-select
														id="performance_group"
														placeholder="Seleccione"
														v-model="formData.performance_group"
														@input="changePerformanceGroup"
														:state="errors.length > 0 ? false : null"
														:options="options.performanceGroups"
													/>

													<small class="text-danger">{{ errors[0] }}</small>
												</validation-provider>
											</b-col>

											<b-col
												v-if="formData.performance_group && formData.performance_group.value === MINERAS"
												md="4"
												cols="12"
												class="mb-2"
											>
												<label for="operationUnit">
													<strong>UNIDAD DE OPERACIÓN</strong>
												</label>
												<validation-provider
													#default="{ errors }"
													rules="required"
													name="Unidad de Operación"
												>
													<v-select
														id="operationUnit"
														placeholder="Seleccione"
														v-model="formData.operation_unit"
														:state="errors.length > 0 ? false : null"
														:options="options.operationUnits"
													/>

													<small class="text-danger">{{ errors[0] }}</small>
												</validation-provider>
											</b-col>
										</template>

									<provider-performance-backfill
										v-model="manual_cycles"
										:has-performance="!!(formData.has_performance && formData.has_performance.value)"
									/>
									</b-row>
								</b-card>
							</b-col>
						</b-row>

						<b-row class="small text-muted">
							<b-col cols="12">
								<span class="text-danger">*</span> Campos obligatorios
							</b-col>
							<b-col cols="12">
								<span class="text-info">*</span> Campos obligatorios para evaluación de desempeño
							</b-col>
						</b-row>

						<template #footer>
							<!-- BUTTON SUBMIT -->
							<b-button-loading
								text="AGREGAR"
								type="submit"
								:processing="processing"
							></b-button-loading>
						</template>
					</b-card>
				</b-col>
			</b-row>
		</b-form>
	</validation-observer>
</template>

<script>
import useNotifications from "@notifications"
import { PerformanceGroups } from "@core/utils/data"
import BButtonLoading from "@core/components/b-button-loading/BButtonLoading.vue"
import { ref, onBeforeMount, onUnmounted } from "@vue/composition-api"
import { ValidationProvider, ValidationObserver } from "vee-validate"
import providerStoreModule from "../providerStoreModule"
import ProviderPerformanceBackfill from "../ProviderPerformanceBackfill.vue"
import { Spanish } from "flatpickr/dist/l10n/es"
import flatPickr from "vue-flatpickr-component"
import Ripple from "vue-ripple-directive"
import { required, email } from "@validations"
import { v4 as uuidv4 } from "uuid"
import vSelect from "vue-select"
import router from "@/router"
import moment from "moment"
import store from "@/store"
import axios from "@axios"

export default {
	components: {
		ProviderPerformanceBackfill,
		ValidationProvider,
		ValidationObserver,

		BButtonLoading,

		flatPickr,
		required,
		email,
		vSelect
	},
	directives: {
		Ripple
	},
	setup() {
		// USE TOAST
		const { toastNotification } = useNotifications()
		const { MINERAS, CONEXAS } = PerformanceGroups

		// REFS
		const refForm = ref(null)

		const onlyDateConfig = ref({
			enableTime: false,
			locale: Spanish,
			minDate: moment().format("YYYY-MM-DD")
		})

		const formData = ref({
			name: null,
			alias: null,
			ruc: null,
			physical_address: null,
			general_manager: null,
			email: null,
			businessArea: null,
			has_performance: null,
			order_number: null,
			performance_group: null,
			operation_unit: null
		})

		const processing = ref(false)
		const options = ref({})
		const manual_cycles = ref([])
		const other_emails = ref([
			{
				id: uuidv4(),
				email: null
			}
		])

		const PROVIDER_APP_STORE_MODULE_NAME = "app-provider"

		// REGISTER MODULE
		if (!store.hasModule(PROVIDER_APP_STORE_MODULE_NAME))
			store.registerModule(PROVIDER_APP_STORE_MODULE_NAME, providerStoreModule)

		// UNREGISTER ON LEAVE
		onUnmounted(() => {
			if (store.hasModule(PROVIDER_APP_STORE_MODULE_NAME))
				store.unregisterModule(PROVIDER_APP_STORE_MODULE_NAME)
		})

		// CALL FUNCTION TO POPULATE OPTIONS FOR THE FILTERS
		onBeforeMount(() => {
			getSelectFilters()
		})

		const getSelectFilters = async () => {
			const businessAreas = await axios.get("/selectors/business-areas")
			const performanceGroups = await axios.get("/selectors/performance-groups")
			const operationUnits = [
				{ label: "SANTA MARÍA", value: "SANTA MARÍA" },
				{ label: "MARAÑÓN", value: "MARAÑÓN" },
				{ label: "TODOS", value: "TODOS" }
			]
			const hasPerformances = [
				{ label: "NO", value: 0 },
				{ label: "SÍ", value: 1 }
			]
			options.value = {
				...businessAreas.data,
				...performanceGroups.data,
				operationUnits,
				hasPerformances
			}
		}

		const resetFormData = () => {
			formData.value = {
				name: null,
				alias: null,
				ruc: null,
				physical_address: null,
				general_manager: null,
				email: null,
				businessArea: null,
				has_performance: null,
				order_number: null,
				performance_group: null,
				operation_unit: null
			}
		}

		const changeHasPerformance = (e) => {
			formData.value.order_number = null
			formData.value.performance_group = null
			formData.value.operation_unit = null
		}

		const changePerformanceGroup = (e) => {
			formData.value.operation_unit = null
		}

		const addSecondaryEmail = () => {
			other_emails.value.push({
				id: uuidv4(),
				email: null
			})
		}

		const removeSecondaryEmail = (index) => {
			other_emails.value.splice(index, 1)
		}

		const onSubmit = async () => {
			const isValid = await refForm.value.validate()

			if (!isValid) {
				toastNotification("Complete los campos requeridos.", false)
				return
			}

			processing.value = true

			const alternate_emails = other_emails.value
				.filter((item) => item.email)
				.map((item) => item.email)

			const payload = {
				name: formData.value.name,
				alias: formData.value.alias,
				ruc: formData.value.ruc,
				physical_address: formData.value.physical_address,
				general_manager: formData.value.general_manager,
				email: formData.value.email,
				business_area_id: formData.value.businessArea?.value || null,
				has_performance: formData.value.has_performance?.value || null,
				order_number: formData.value.order_number,
				performance_group_id: formData.value.performance_group?.value || null,
				operation_unit: formData.value.operation_unit?.value || null,
				alternate_emails,
				manual_cycles: manual_cycles.value
			}

			store
				.dispatch("app-provider/createProvider", payload)
				.then((response) => {
					toastNotification(response.data.message)

					resetFormData()
					manual_cycles.value = []
					refForm.value.reset()

					router.push({ name: "providers-list" })
				})
				.catch((err) => {
					const message =
						err.response.data.message || "Error al agregar proveedor"
					toastNotification(message, false)
				})
				.finally(() => (processing.value = false))
		}

		return {
			// DATA
			onlyDateConfig,
			processing,
			formData,
			options,
			other_emails,
			manual_cycles,

			// REFS
			refForm,
			MINERAS,
			CONEXAS,

			// METHODS
			changeHasPerformance,
			changePerformanceGroup,
			addSecondaryEmail,
			removeSecondaryEmail,
			onSubmit
		}
	}
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>